export default "__VITE_ASSET__BnJU6Rpy__"